<template>
    <button
        type="button"
        class="d-flex flex-nowrap flex-md-wrap align-items-center preferences-wrapper btn btn-link p-0 text-decoration-none cursor-pointer w-100 text-uppercase justify-content-center"
        @click="openSection('preferences')"
    >
        <span>
            {{ locale.getLanguageInstance().native_name }}
        </span>
        <span class="mx-2">|</span>
        <span>
            {{ locale.ship_country.name }}
        </span>
        <span class="mx-2">|</span>
        <span v-html="currency.html_sign"/>
    </button>
</template>

<script setup>
const PreferencesModal = defineAsyncComponent(() => import('~/components/Modals/PreferencesModal.vue'))
import { useLocaleStore } from '~/stores/LocaleStore'
import { useModal } from '~/stores/ModalStore'

const locale = useLocaleStore()
const modals = useModal()
const section = ref('')

const currency = locale.currency;


function openSection(name) {
    section.value = name
    modals.openModal('PreferencesModal', PreferencesModal)
}
</script>

<style scoped>
a.btn-link {
    padding: 0;
    text-decoration: none;
}

span {
    padding: 0 !important;
}
</style>
